module.exports = __webpack_public_path__ + "img/saven_selection_picto.fec251a3.png";